// MUI Imports
import { useTheme } from '@mui/material/styles'

// Third-party Imports
import PerfectScrollbar from 'react-perfect-scrollbar'

// Type Imports
import type { VerticalMenuContextProps } from '@menu/components/vertical-menu/Menu'

// Component Imports
import { Menu, MenuItem, SubMenu } from '@menu/vertical-menu'

// Hook Imports
import useVerticalNav from '@menu/hooks/useVerticalNav'

// Styled Component Imports
import StyledVerticalNavExpandIcon from '@menu/styles/vertical/StyledVerticalNavExpandIcon'

// Style Imports
import menuItemStyles from '@core/styles/vertical/menuItemStyles'
import menuSectionStyles from '@core/styles/vertical/menuSectionStyles'

type RenderExpandIconProps = {
  open?: boolean
  transitionDuration?: VerticalMenuContextProps['transitionDuration']
}

type Props = {
  scrollMenu: (container: any, isPerfectScrollbar: boolean) => void
}

const RenderExpandIcon = ({ open, transitionDuration }: RenderExpandIconProps) => (
  <StyledVerticalNavExpandIcon open={open} transitionDuration={transitionDuration}>
    <i className='tabler-chevron-right' />
  </StyledVerticalNavExpandIcon>
)

const VerticalMenu = ({ scrollMenu }: Props) => {
  // Hooks
  const theme = useTheme()
  const verticalNavOptions = useVerticalNav()

  // Vars
  const { isBreakpointReached, transitionDuration } = verticalNavOptions

  const ScrollWrapper = isBreakpointReached ? 'div' : PerfectScrollbar

  return (
    // eslint-disable-next-line lines-around-comment
    /* Custom scrollbar instead of browser scroll, remove if you want browser scroll only */
    <ScrollWrapper
      {...(isBreakpointReached
        ? {
            className: 'bs-full overflow-y-auto overflow-x-hidden',
            onScroll: container => scrollMenu(container, false)
          }
        : {
            options: { wheelPropagation: false, suppressScrollX: true },
            onScrollY: container => scrollMenu(container, true)
          })}
    >
      {/* Incase you also want to scroll NavHeader to scroll with Vertical Menu, remove NavHeader from above and paste it below this comment */}
      {/* Vertical Menu */}
      <Menu
        popoutMenuOffset={{ mainAxis: 23 }}
        menuItemStyles={menuItemStyles(verticalNavOptions, theme)}
        renderExpandIcon={({ open }) => <RenderExpandIcon open={open} transitionDuration={transitionDuration} />}
        renderExpandedMenuItemIcon={{ icon: <i className='tabler-circle text-xs' /> }}
        menuSectionStyles={menuSectionStyles(verticalNavOptions, theme)}
      >
        <MenuItem href='/admin' icon={<i className='tabler-smart-home' />}>
          Inicio
        </MenuItem>
        <MenuItem href='/admin/usuarios/listar' icon={<i className='tabler-user-up' />}>
          Usuarios
        </MenuItem>
        <MenuItem href='/admin/puestos/listar' icon={<i className='tabler-briefcase' />}>
          Puestos
        </MenuItem>
        <MenuItem href='/admin/empleados/listar' icon={<i className='tabler-user-down' />}>
          Empleados
        </MenuItem>
        <SubMenu label={'Seguridad'} icon={<i className='tabler-lock' />}>
          <MenuItem href='/admin/permisos/listar'>Permisos</MenuItem>
          <MenuItem href='/admin/roles/listar'>Roles</MenuItem>
        </SubMenu>
        <MenuItem href='/admin/tiendas/listar' icon={<i className='tabler-building-store' />}>
          Tiendas
        </MenuItem>
        <MenuItem href='/admin/formas-de-pago/listar' icon={<i className='tabler-report-money' />}>
          Formas de Pago
        </MenuItem>
        <SubMenu label={'Productos'} icon={<i className='tabler-cube' />}>
          <MenuItem href='/admin/productos/listar'>Catalogo</MenuItem>
          <MenuItem href='/admin/grupo-de-precios/listar'>Grupo de Precios</MenuItem>
        </SubMenu>
        <MenuItem href='/admin/promociones/listar' icon={<i className='tabler-brand-producthunt' />}>
          Promociones
        </MenuItem>
        <MenuItem href='/admin/clientes/listar' icon={<i className='tabler-users-group' />}>
          Clientes
        </MenuItem>
        <MenuItem href='/admin/about' icon={<i className='tabler-info-circle' />}>
          Acerca de
        </MenuItem>
      </Menu>
      {/* <Menu
        popoutMenuOffset={{ mainAxis: 23 }}
        menuItemStyles={menuItemStyles(verticalNavOptions, theme)}
        renderExpandIcon={({ open }) => <RenderExpandIcon open={open} transitionDuration={transitionDuration} />}
        renderExpandedMenuItemIcon={{ icon: <i className='tabler-circle text-xs' /> }}
        menuSectionStyles={menuSectionStyles(verticalNavOptions, theme)}
      >
        <GenerateVerticalMenu menuData={menuData(dictionary)} />
      </Menu> */}
    </ScrollWrapper>
  )
}

export default VerticalMenu
